import { render, staticRenderFns } from "./community.vue?vue&type=template&id=2db7399a&scoped=true&"
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"
import style0 from "./community.vue?vue&type=style&index=0&id=2db7399a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7399a",
  null
  
)

export default component.exports